/**
 * Utility function to get and parse refresh interval from localStorage
 * @param {number} defaultValue - Default refresh interval in seconds if none found
 * @returns {number} Parsed refresh interval in seconds
 */
export const getRefreshInterval = (defaultValue = 300) => {
  // Default 300 seconds (5 minutes)
  const stored = localStorage.getItem("refresh_interval");
  if (!stored) return defaultValue;

  const parsed = parseInt(stored, 10);
  return isNaN(parsed) ? defaultValue : parsed;
};

/**
 * Convert a refresh interval in seconds to TanStack Query refetchInterval (ms)
 * @param {number} seconds - Interval in seconds
 * @param {number|false} fallback - Fallback value when seconds is invalid
 * @returns {number|false} Interval in milliseconds, or fallback
 */
export const secondsToRefetchIntervalMs = (seconds, fallback = false) => {
  const parsedSeconds = Number(seconds);
  return Number.isFinite(parsedSeconds) && parsedSeconds > 0
    ? parsedSeconds * 1000
    : fallback;
};

/**
 * Read user refresh interval from storage and convert to milliseconds
 * @param {number} defaultValue - Default interval in seconds if none found
 * @param {number|false} fallback - Fallback value when interval is invalid
 * @returns {number|false} Interval in milliseconds, or fallback
 */
export const getRefetchIntervalMs = (defaultValue = 300, fallback = false) => {
  return secondsToRefetchIntervalMs(getRefreshInterval(defaultValue), fallback);
};
